import HandTiles from "./HandTiles";
import { CARD_DATA } from "../cardData";

export default function WitnessReviewModal({requests,friends,onConfirm,onDecline,onClose}){
  if(!requests?.length)return null;
  const req=requests[0];const from=friends.find(u=>u.uid===req.fromId);
  const hand=CARD_DATA[req.catIdx]?.hands[req.handIdx];
  return(
    <div className="modal-overlay" onClick={onClose}><div className="modal-sheet" onClick={e=>e.stopPropagation()}>
      <div className="modal-handle"/>
      <div className="modal-title">Witness Request</div>
      <div style={{fontSize:13,color:"var(--text-dim)",marginBottom:10}}><strong style={{color:"var(--text)"}}>{from?.name||"Someone"}</strong> wants you to confirm this hand:</div>
      <div className="witness-hand-display"><div className="witness-hand-tiles"><HandTiles groups={hand?.groups||[]}/></div></div>
      <div className="witness-actions"><button className="witness-confirm-btn decline" onClick={()=>onDecline(req.id)}>Decline</button><button className="witness-confirm-btn approve" onClick={()=>onConfirm(req.id)}>Confirm</button></div>
      <div className="modal-cancel" onClick={onClose}>Later</div>
    </div></div>
  );
}
